import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ProfileLayout = lazy(() => import('@/pages/profile/layout'));
const ProfileIndexPage = lazy(() => import('@/pages/profile'));
const ProfileOverallPage = lazy(() => import('@/pages/profile/overall'));
const ProfileDocumentsPage = lazy(() => import('@/pages/profile/documents'));
const ProfileSettingsPage = lazy(() => import('@/pages/profile/settings'));
const ProfilePermissionsPage = lazy(() => import('@/pages/profile/permissions'));

/**
 * `/profile/*` — the session user's Workspace shell (Profile / Documents /
 * Settings / Permissions, UG-5193 read-only). No routeAccess rule: any authenticated user manages their own
 * profile; the Documents tab hides via the nav's permission filter and the
 * API enforces ownership. `ProfileLayout` mounts the section breadcrumb and
 * the toolbar chrome; the bare URL redirects to `/overall`.
 */
export const profileRoutes: RouteConfig = {
  path: '/profile',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: ProfileLayout,
      children: [
        { path: '', element: ProfileIndexPage },
        { path: '/overall', element: ProfileOverallPage },
        { path: '/documents', element: ProfileDocumentsPage },
        { path: '/settings', element: ProfileSettingsPage },
        { path: '/permissions', element: ProfilePermissionsPage },
      ],
    },
  ],
};
